import { Box } from "@mantine/core";
import { IdeaTable } from "../../../components/idea-table/IdeaTable";

const IdeaInboxPage = () => {
    return (
        <Box style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <IdeaTable maxHeight="100%" />
        </Box>
    );
};

export default IdeaInboxPage;
